import { Error404Page } from "@sleek/customer-common-acquisition";

const routes = [
  {
    path: "/acquisition/save-for-later",
    name: "save-for-eternity-later",
    component: () =>
      import(
        /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/containers/beta/Beta.vue"
      ),
    children: [
      {
        path: "",
        name: "save-for-later",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/save-for-later/SaveForLater.vue"
          ),
      },
    ],
  },
  {
    path: "/acquisition/entity",
    name: "sleek-bundle-entity",
    component: () =>
      import(
        /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/containers/beta/Beta.vue"
      ),
    children: [
      {
        path: "",
        name: "service-entity-business",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/entity-page/EntityPage.vue"
          ),
      },
      {
        path: "service-dormant-company-confirmation",
        name: "service-dormant-company-confirmation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/dormant-company-confirm/DormantCompanyConfirm.vue"
          ),
      },
    ],
  },
  {
    path: "/acquisition/package/:bundleId",
    name: "sleek-bundle",
    component: () =>
      import(
        /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/containers/beta/Beta.vue"
      ),
    children: [
      {
        path: "",
        name: "bundle-loading",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/shared/pages/start-page/StartPage.vue"
          ),
      },
      {
        path: "company-name",
        name: "company-name",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/company-name/CompanyName.vue"
          ),
      },
      {
        path: "service-nominee-director",
        name: "service-nominee-director",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-sg" */ "@/modules/sleek-onboarding/bundle/pages/nominee-director/NomineeDirector.vue"
          ),
      },
      {
        path: "service-corporate-secretary",
        name: "service-corporate-secretary",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-sg" */ "@/modules/sleek-onboarding/bundle/pages/shareholders-sg/ShareholderNewUI.vue"
          ),
      },
      {
        path: "service-company-secretary",
        name: "service-company-secretary",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-hk" */ "@/modules/sleek-onboarding/bundle/pages/shareholders-hk/Shareholders.vue"
          ),
      },
      {
        path: "service-mailroom",
        name: "service-mailroom",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-sg" */ "@/modules/sleek-onboarding/bundle/pages/mailroom/Mailroom.vue"
          ),
      },
      {
        path: "service-accounting",
        name: "service-accounting",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-sg" */ "@/modules/sleek-onboarding/bundle/pages/accounting/Accounting.vue"
          ),
      },
      {
        path: "service-audit-and-tax",
        name: "service-audit-and-tax",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-hk" */ "@/modules/sleek-onboarding/bundle/pages/audit-and-tax/AuditAndTax.vue"
          ),
      },
      {
        path: "service-audit-and-tax-with-premium",
        name: "service-audit-and-tax-with-premium",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-hk" */ "@/modules/sleek-onboarding/bundle/pages/audit-and-tax/AuditAndTaxWithPremium.vue"
          ),
      },
      {
        path: "service-immigration",
        name: "service-immigration",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-sg" */ "@/modules/sleek-onboarding/bundle/pages/immigration/Immigration.vue"
          ),
      },
      // AU
      {
        path: "service-asic-compliance-transfer",
        name: "service-asic-compliance-transfer",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/asic-compliance/ASICCompliance.vue"
          ),
      },
      {
        path: "service-asic-compliance-incorp",
        name: "service-asic-compliance-incorp",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/asic-compliance-incorp/ASICComplianceIncorp.vue"
          ),
      },
      {
        path: "service-abn-tax-compliance",
        name: "service-abn-tax-compliance",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/abnAndTaxCompliance/ABNAndTaxCompliance.vue"
          ),
      },
      {
        path: "service-registered-office",
        name: "service-registered-office",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/virtual-office/VirtualOffice.vue"
          ),
      },
      {
        path: "service-accounting-au",
        name: "service-accounting-au",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/au-accounting/Accounting.vue"
          ),
      },
      {
        path: "service-accounting-active-company",
        name: "service-accounting-active-company",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/accounting-au-transfer/AccountingAuTransfer.vue"
          ),
      },
      {
        path: "service-accounting-sole-trader-new",
        name: "service-accounting-sole-trader-new",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/accounting-au-transfer/AccountingAuTransfer.vue"
          ),
      },
      {
        path: "service-accounting-sole-trader",
        name: "service-accounting-sole-trader",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/accounting/Accounting.vue"
          ),
      },
      {
        path: "service-accounting-dormant",
        name: "service-accounting-dormant",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-dormant" */ "@/modules/sleek-onboarding/bundle/pages/accounting-dormant/AccountingDormant.vue"
          ),
      },
      {
        path: "service-add-ons",
        name: "service-add-ons",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/add-on-services/AddOnServices.vue"
          ),
      },
      {
        path: "service-add-ons-incorporation",
        name: "service-add-ons-incorporation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/add-on-services/AddOnServices.vue"
          ),
      },
      {
        path: "need-accounting-remediation",
        name: "need-accounting-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/need-accounting-remediation/NeedAccountingRemediation.vue"
          ),
      },
      {
        path: "need-compsec-remediation",
        name: "need-compsec-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/need-company-secretary/NeedCompanySecretary.vue"
          ),
      },
      {
        path: "need-audit-remediation",
        name: "need-audit-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/need-audit-remediation/NeedAuditRemediation.vue"
          ),
      },
      {
        path: "audit-remediation",
        name: "audit-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/remediation-audit/RemediationAudit.vue"
          ),
      },
      {
        path: "compsec-remediation",
        name: "compsec-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/remediation-compsec/RemediationCompsec.vue"
          ),
      },
      {
        path: "reconfirm-accounting",
        name: "reconfirm-accounting",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/reconfirmation-accounting/ReconfirmationAccounting.vue"
          ),
      },
      {
        path: "accounting-remediation",
        name: "accounting-remediation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-accounting-incorp-au" */ "@/modules/sleek-onboarding/bundle/pages/remediation/Remediation.vue"
          ),
      },
      // END AU
      {
        path: "checkout",
        name: "checkout",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/checkout/Checkout.vue"
          ),
      },
      {
        path: "payment",
        name: "payment",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/payment/Payment.vue"
          ),
      },
      {
        path: "payment-completion",
        name: "payment-completion",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentCompletion.vue"
          ),
      },
      {
        path: "pay-now-transfer",
        name: "pay-now-transfer",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentPayNowTransfer.vue"
          ),
      },
      {
        path: "bank-transfer",
        name: "bank-transfer",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentBankTransfer.vue"
          ),
      },
    ],
  },
  {
    path: "/acquisition/package-uk/:bundleId",
    name: "sleek-bundle-uk",
    component: () =>
      import(
        /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/containers/beta-uk/Beta.vue"
      ),
    children: [
      {
        path: "",
        name: "bundle-loading",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/shared/pages/start-page/StartPage.vue"
          ),
      },
      {
        path: "company-name-uk",
        name: "company-name-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/company-name-uk/CompanyName.vue"
          ),
      },
      {
        path: "point-of-contact",
        name: "point-of-contact",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-beta" */ "@/modules/sleek-onboarding/bundle/pages/point-of-contact/PointOfContact.vue"
          ),
      },
      {
        path: "company-director",
        name: "company-director",
        component: () =>
          import(
            /* webpackChunkName: "company-director" */ "@/modules/sleek-onboarding/bundle/pages/company-director/CompanyDirector.vue"
          ),
      },
      {
        path: "company-secretary",
        name: "company-secretary",
        component: () =>
          import(
            /* webpackChunkName: "company-secretary" */ "@/modules/sleek-onboarding/bundle/pages/company-secretary-uk/CompanySecretary.vue"
          ),
      },
      {
        path: "shareholders-uk",
        name: "shareholders-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/shareholders-uk/Shareholders.vue"
          ),
      },
      {
        path: "registered-office-uk",
        name: "registered-office-uk",
        component: () =>
          import(
            /* webpackChunkName: "registered-office-uk" */ "@/modules/sleek-onboarding/bundle/pages/registered-office-uk/RegisteredOfficeUK.vue"
          ),
      },
      {
        path: "service-add-ons-uk",
        name: "service-add-ons-uk",
        component: () =>
          import(
            /* webpackChunkName: "service-add-ons-uk" */ "@/modules/sleek-onboarding/bundle/pages/add-on-services-uk/AddOnServices.vue"
          ),
      },
      {
        path: "accounting-uk",
        name: "accounting-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/accounting-uk/Accounting.vue"
          ),
      },
      {
        path: "business-account-uk",
        name: "business-account-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/business-account-uk/BusinessAccountUk.vue"
          ),
      },
      {
        path: "checkout",
        name: "checkout-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/checkout-uk/Checkout.vue"
          ),
      },
      {
        path: "checkout-addon",
        name: "checkout-and-addon-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/checkout-and-addon-uk/CheckoutAndAddon.vue"
          ),
      },
      {
        path: "payment",
        name: "payment-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment" */ "@/modules/sleek-onboarding/bundle/pages/payment/Payment.vue"
          ),
      },
      {
        path: "payment-completion",
        name: "payment-completion-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentCompletion.vue"
          ),
      },
      {
        path: "payment-completion-shorter",
        name: "payment-completion-uk-shorter",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete-uk/PaymentCompletion.vue"
          ),
      },
      {
        path: "thank-you",
        name: "thank-you-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/thank-you-uk/ThankYou.vue"
          ),
      },
      {
        path: "pay-now-transfer",
        name: "pay-now-transfer-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentPayNowTransfer.vue"
          ),
      },
      {
        path: "bank-transfer",
        name: "bank-transfer-uk",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/payment-complete/PaymentBankTransfer.vue"
          ),
      },
      {
        path: "questionnaire",
        name: "questionnaire",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/questionnaire-uk/Questionnaire.vue"
          ),
      },
      {
        path: "recommendation",
        name: "recommendation",
        component: () =>
          import(
            /* webpackChunkName: "onboarding-bundle-payment-completion" */
            "@modules/sleek-onboarding/bundle/pages/recommendation-uk/Recommendation.vue"
          ),
      },
      {
        path: "additional-accounting",
        name: "additional-accounting",
        component: () =>
          import(
            "@modules/sleek-onboarding/bundle/pages/additional-accounting-uk/AdditionalAccounting.vue"
          ),
      },
    ],
  },
  {
    path: "/acquisition/*",
    name: "Error 404 - Page Not Found",
    component: Error404Page,
  },
];

export default routes;
